import { render } from "./MaterialInfo.vue?vue&type=template&id=7da61f02"
import script from "./MaterialInfo.vue?vue&type=script&lang=js"
export * from "./MaterialInfo.vue?vue&type=script&lang=js"

import "./MaterialInfo.vue?vue&type=style&index=0&id=7da61f02&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__